import { InvalidExchangeTokenNotification } from "%notifications";
import { pushNotification } from "%error/utils";

import router from "%root/router";

export default {
  supports(status, code) {
    return status === 401 && code === "INVALID_TOKEN";
  },

  handle() {
    pushNotification(InvalidExchangeTokenNotification);
    router.push("/admin");
  }
};
